import { observer } from 'mobx-react-lite'
import { Box } from '@mui/material'
import { TeamRolesList } from '../component/molecules/TeamRolesList'

export type MyTeamRolesPageProps = {
  levelId: string
  levelName: string
}

export const MyTeamRolesPage = observer(({ levelId, levelName }: MyTeamRolesPageProps) => {
  return (
    <Box sx={styles.root}>
      <TeamRolesList levelId={levelId} levelName={levelName} />
    </Box>
  )
})

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: { xs: '1rem', md: '1rem 5rem' },
  },
}
